<template>
  <div class="compare-targets-table">
    <div class="compare-targets-table__header">
      <div
        v-for="name in targetNames"
        :key="name"
      >
        {{ name }}
      </div>
    </div>
    <div
      v-for="({ name, personalValue, economyValue, type }, index) in tableRows"
      :key="name"
      class="compare-targets-table__row"
    >
      <div
        class="compare-targets-table__name"
        v-html="name"
      />
      <SkeletonOneString
        v-if="!index && !minPersonalPrice"
        :height="20"
        width="37px"
        :border-radius="8"
        margin="0"
      />
      <div
        v-else-if="type === 'text'"
        class="compare-targets-table__personal-value"
        v-html="personalValue"
      />
      <sprite
        v-else
        :src="`sprites_${personalValue}`"
        :class="`compare-targets-table__${personalValue}`"
      />
      <div
        class="compare-targets-table__economy-value"
      >
        <SkeletonOneString
          v-if="!index && !minEconomyPrice"
          :height="20"
          width="37px"
          :border-radius="8"
          margin="0"
        />
        <div
          v-else-if="type === 'text'"
          v-html="economyValue"
        />
        <div
          v-else
          :class="`compare-targets-table__${economyValue}-wrapper`"
        >
          <sprite
            :src="`sprites_${economyValue}`"
            :class="`compare-targets-table__${economyValue}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonOneString from '@/components/core/ui/SkeletonOneString'

export default {
  name: 'CompareTargetsTable',

  components: {
    SkeletonOneString,
  },

  props: {
    minPersonalPrice: {
      type: Number,
      default: 0,
    },

    minEconomyPrice: {
      type: Number,
      default: 0,
    },
  },

  data () {
    return {
      targetNames: [
        'Персональный',
        'Эконом',
      ],
    }
  },

  computed: {
    textSeparator () {
      return this.$isSmartphone ? '<br>' : ' '
    },

    tableRows () {
      return [
        {
          name: 'Стоимость в день, от',
          personalValue: `${this.minPersonalPrice} ₽`,
          economyValue: `${this.minEconomyPrice} ₽`,
          type: 'text',
        },
        {
          name: 'Разнообразие, блюд',
          personalValue: '400+',
          economyValue: '150',
          type: 'text',
        },
        {
          name: `Бесплатная доставка${this.textSeparator}каждые`,
          personalValue: '2 дня',
          economyValue: '3 дня',
          type: 'text',
        },
        {
          name: `Вкусная,${this.textSeparator}полезная еда`,
          personalValue: 'check-rounded',
          economyValue: 'check-rounded',
          type: 'icon',
        },
        {
          name: 'Замена блюд',
          personalValue: 'check-rounded',
          economyValue: 'cross-smooth',
          type: 'icon',
        },
        {
          name: `Исключение${this.textSeparator}ингредиентов`,
          personalValue: 'check-rounded',
          economyValue: 'cross-smooth',
          type: 'icon',
        },
        {
          name: `Часовые интервалы${this.textSeparator}доставки`,
          personalValue: 'check-rounded',
          economyValue: 'cross-smooth',
          type: 'icon',
        },
        {
          name: `План похудения${this.textSeparator}по вашим<br>параметрам`,
          personalValue: 'check-rounded',
          economyValue: 'cross-smooth',
          type: 'icon',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.compare-targets-table {
  position: relative;
  background-color: white;
  border-radius: 24px 24px 0 0;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    height: 36px;
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  &__row {
    height: 64px;
    display: flex;
    align-items: center;
    gap: 20px;
    border-top: 0.5px solid map-get($colors, 'grey_12');
    font-size: 14px;
    line-height: 20px;
  }

  &__name {
    margin-right: auto;
  }

  &__personal-value {
    text-align: right;
  }

  &__economy-value {
    flex-basis: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__check-rounded {
    height: 23px;
    width: 23px;
    fill: map-get($colors, 'default');
    margin-right: -2px;
  }

  &__check-rounded-wrapper {
    flex-basis: 70px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__cross-smooth-wrapper {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: map-get($colors, 'grey_20');
  }

  &__cross-smooth {
    width: 8px;
    height: 8px;
    color: map-get($colors, 'white');
  }
}
</style>
